import ApiService from '@/services/ApiService';
import ErrorService from '@/services/ErrorService';

export default {
  search(term) {
    return ApiService().get(`/customer/search/${term}`);
  },
  // todo: reprint not show group
  getAll() {
    return ApiService().get('/customer/list');
  },

  getCustomerTypeList() {
    return ApiService().get('/customer-type/list');
  },

  postCustomer(obj) {
    return ApiService()
      .post(`/customer`, obj, true)
      .then(response => {
        if(response.code) {
          return ErrorService.inlineError(response);
        }
        return true;
      });
  }, 
};
